if (!customElements.get('free-shipping-message')) {
  class FreeShippingMessage extends HTMLElement {
    connectedCallback() {
      this.updateStatus();
    }

    updateStatus() {
      const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      const freeShippingThreshold = Math.round(
        parseInt(this.dataset.shippingAmount, 10) * (Shopify.currency.rate || 1)
      );
      const isEligible = cartTotal >= freeShippingThreshold;

      this.hidden = !isEligible;
      this.classList.toggle('is-eligible', isEligible);
    }
  }

  customElements.define('free-shipping-message', FreeShippingMessage);

  document.addEventListener('cartUpdated', () => {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('free-shipping-message').forEach((message) => {
          message.dataset.cartTotal = cart.total_price;
          message.updateStatus();
        });
      })
      .catch((error) => console.error('Error updating free shipping message:', error));
  });
}
